import React, { useState, useEffect } from "react";
import Aos from "aos";
import 'aos/dist/aos.css';
import CountUp from "react-countup";

const AboutUs = () => {
  const [triggerCount, setTriggerCount] = useState(false);

  useEffect(() => {
  const onScroll = () => {
    const element = document.getElementById("years-counter");
    if (element && !triggerCount) {
      const rect = element.getBoundingClientRect();
      if (rect.top <= window.innerHeight) {
        setTriggerCount(true); // Set it true only once
      }
    }
  };

  window.addEventListener("scroll", onScroll);
  return () => window.removeEventListener("scroll", onScroll);
}, [triggerCount]);


  useEffect(() => {
    Aos.init({ duration: 1200, once: false });
  }, []);

  return (
    <section
      id="aboutus"
      className="pt-0 snap-start snap-y snap-mandatory overflow-hidden min-h-screen bg-white"
      style={{ backgroundImage: `url('/About-bg.png')` }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-10 grid grid-cols-1 md:grid-cols-3 gap-10 items-center">

        {/* Left Column - Just Heading */}
        <div className="md:col-span-1 -mt-6" data-aos="fade-up">
          <h2 className="text-3xl sm:text-7xl font-bold font-poppins text-sky-400">
            About Us
          </h2>
        </div>

        {/* Right Column - Rest Content */}
        <div className="md:col-span-2 space-y-6 w-full mt-10 ml-4" data-aos="fade-down">
          <p  className="text-lg text-white font-roboto leading-relaxed text-justify">
            Sairaj Infotech is a trusted IT infrastructure and service provider,
            dedicated to delivering innovative, secure, and scalable technology solutions.
            With a client-first approach and a team of experienced professionals, we empower
            organizations to embrace the future with confidence.
          </p>
          <p className="text-white font-roboto">
            From managed services and hardware solutions to cloud infrastructure and IT consulting,
            we ensure your business stays ahead in a digital world.
          </p>

          {/* Text + Counter */}
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div className="text-white font-roboto text-base md:text-lg">
              <p>
                Delivering excellence through expert services, timely support, and unmatched reliability.
              </p>
            </div>

            {/* Counter Box */}
            <div
              id="years-counter"
              className="p-8 bg-blue-50 border-l-8 border-sky-400 rounded-lg shadow-sm w-fit"
            >
              <h3 className="text-4xl font-bold text-blue-950">
                {triggerCount ? <CountUp end={15} duration={3} /> : 10}+
              </h3>
              <p className="text-gray-800 font-semibold mt-1 text-2xl">
                Years in the Industry
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default AboutUs;
